import { Injectable } from '@angular/core';
import {
  AppParametersService,
  AppState,
  RealEstateObjectId,
  ResultsState,
} from '@immosky/types';
import { select, Store } from '@ngrx/store';
import { selectResultsState } from '../state/results/results.selectors';
import {
  DetailPageService,
  DetailPageUrlOrigin,
  LocalStorage,
} from '@immosky/shared';
import { ObjectSearchAppParameters } from './object-search-app-parameters.service';

@Injectable({
  providedIn: 'root',
})
export class ObjectSearchDetailPageService extends DetailPageService {
  private resultsState!: ResultsState;

  constructor(
    private appParametersService: AppParametersService<ObjectSearchAppParameters>,
    private store: Store<AppState>
  ) {
    super();
    this.store
      .pipe(select(selectResultsState))
      .subscribe((resultsState: ResultsState) => {
        this.resultsState = resultsState;
      });
  }

  getDetailPageUrlForId(id: RealEstateObjectId) {
    return this.appParametersService.get().detailPageUrl.replace('{id}', id);
  }

  goTo(pageUrl: string, origin: DetailPageUrlOrigin) {
    switch (origin) {
      case 'list-card':
        LocalStorage.updateForDetailPage(
          this.resultsState.searchResults.realEstateObjects
        );
        break;
      case 'map-card':
        LocalStorage.updateForDetailPage(this.resultsState.mapResults.results);
        break;
    }

    window.location.href = pageUrl;
  }
}
